import { createSelector } from 'reselect'

const base = (state) => state.app
export const selectSnackbar = createSelector(base, (b) => b.snackbar)
